module.exports = __webpack_public_path__ + "static/14-7984f3fdc36700a6cbc12b65fb73a6d0.jpg";